<template>
    <form class="h-full w-full dark:text-white">
        <div class="mb-4 flex items-center">
            <span v-if="input.year">
                {{ input.year }}
            </span>
            <div v-else>
                <element-placeholder width="w-36" height="h-4"/>
            </div>

            <span>&nbsp;-&nbsp;</span>

            <span v-if="input.name">
                {{ input.name }}
            </span>
            <div v-else>
                <element-placeholder width="w-56" height="h-4"/>
            </div>
        </div>

        <div class="space-y-4">
            <input-group name="year" :label="$t('date.year')">
                <datepicker v-model="input.year" type="year" format="YYYY"></datepicker>
            </input-group>
            <input-group v-model="input.name" name="name" :label="$t('general.name')"/>
        </div>
    </form>
</template>

<script>
import Store from '@/Models/Store';
import Budget from '@/Models/Budget';

export default {
    props: {
        store: Store,
        value: Budget,
    },

    data() {
        return {
        };
    },

    computed: {
        input: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>
